async function toggleSelection(mattressId, mattressHandle) {
    const parentSectionElements = document.querySelectorAll('.variable-section');
    const processedSections = new Set();
    const promises = [];
  
    parentSectionElements.forEach(parentSectionElement => {
      const sectionId = parentSectionElement.getAttribute('data-section');
  
      if (processedSections.has(sectionId)) {
        return;
      }
      processedSections.add(sectionId);
  
      const productId = mattressId;
      const productHandle = mattressHandle;
      const pageType = window.location.pathname.split('/')[window.location.pathname.split('/').length - 2];
  
      const promise = fetch(`/${pageType}/${productHandle}?sections=${sectionId}&product_id=${productId}`)
        .then(response => response.json())
        .then(responseData => {
          const content = responseData[sectionId];
          const parser = new DOMParser();
          const docFragment = parser.parseFromString(content, 'text/html');
          const newElement = docFragment.body.firstChild;
  
          const targetElement = newElement.querySelector(`#mattress-type-selector [data-product-id='${productId}']`);
          if (targetElement) {
            targetElement.setAttribute('data-active', 'true');
            for (let sibling of targetElement.parentNode.children) {
              if (sibling !== targetElement) {
                sibling.setAttribute('data-active', 'false');
              }
            }
          }
  
          const sectionElement = parentSectionElement.classList.contains('variable-media-modal')
            ? document.getElementById(parentSectionElement.id)
            : document.getElementById(parentSectionElement.parentNode.id);
  
          newElement.style.opacity = 0;
          newElement.style.transition = 'opacity 0.3s ease-in-out';
          sectionElement.replaceWith(newElement);
          newElement.style.opacity = 1;
  
          if (targetElement) {
            targetElement.dispatchEvent(new Event("toggle-action-updated", { bubbles: true }));
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
  
      promises.push(promise);
    });
  
    await Promise.all(promises);
  
    const delayedMediaElements = document.querySelectorAll('.delayed-media');
    delayedMediaElements.forEach(delayedMediaElement => {
      delayedMediaElement.style.display = 'inline';
    });
    
    const Yotpoapi = new Yotpo.API(yotpo);
    Yotpoapi.refreshWidgets();
    affirm.ui.refresh();
  }